angular.module("whitelabelApp")
    .controller("QuestionSetController", ['$scope', '$routeParams', '$resource', '$http', 'localStorageService', '$location', '$timeout', function ($scope, $routeParams, $resource, $http, localStorageService, $location, $timeout) {
        $scope.loadingStatus = true;
        $scope.name = 'QuestionSetController';
        $scope.params = $routeParams;
        $scope.questionSetId = $routeParams.stepId;

        // Resources
        var QuestionSetResource = $resource('/api/questionset/:questionSetId', {questionSetId:'@id'});        
        var QuestionsResource = $resource('/api/questionset/:questionSetId/questions', { questionSetId: '@id' });
        var SessionDataResource = $resource('/api/session/:sessionId?timestamp=:time', { sessionId: '@id', timestamp: new Date().getTime()});
        
        $scope.questionSet = QuestionSetResource.get({questionSetId: $routeParams.stepId});

        $scope.questionsData = {};        
        $scope.loadData = function () {
            var questionResourceParams = {
                questionSetId: $routeParams.stepId 
            };
            var sessionId = localStorageService.get('sessionId');
            if (sessionId) {
                questionResourceParams.sessionId = sessionId;
            }
            $scope.questions = QuestionsResource.query(questionResourceParams, function () {
                var defaultValues = [];
                // Pre-populate question data with session value
                $scope.questions.forEach(function (q) {
                    var sessionValue = null;
                    var comparitor = function (sessionValue) { return sessionValue.key == q.id };
                    if ($scope.sessionData.filter(comparitor).length) {
                        sessionValue = $scope.sessionData.filter(comparitor)[0].value;
                        if (q.type != 'Text') {
                            var fullValue = q.values.filter(function (questionValue) { return questionValue.key == sessionValue; })[0];
                            $scope.questionsData[q.id] = fullValue;
                        } else {
                            $scope.questionsData[q.id] = sessionValue;
                        }
                    }
                });
                // clone object for manual update call
                $scope.$watch(
                    function() {
                        return $scope.questionsData;
                    }, function(newValue, oldValue) {
                        questionsDataWatch(newValue, oldValue);
                    }, true);
                var objs = [{}, $scope.questionsData],
                    initialState = objs.reduce(function (r, o) {
                        Object.keys(o).forEach(function (k) {
                            r[k] = o[k];
                        });
                        return r;
                    }, {});
                $scope.questions.forEach(function (q) {
                    if (q.type == 'Radio') {
                        q.selectedValue = null;
                    } else if (q.type == 'Slider') {
                        if ("undefined" === typeof ($scope.questionsData[q.id])) {
                            // Set default (and trigger update)
                            $scope.questionsData[q.id] = q.values[Math.round((q.values.length - 1) / 2)];
                        }
                        var selectedValue = $scope.questionsData[q.id];
                        q.legend = selectedValue.value;
                        q.selected = selectedValue.key;
                        $scope.onSliderEnd(q.id, q.selected, null, null);
                        q.sliderOptions = {
                            id: q.id,
                            hidePointerLabels: true,
                            showTicks: true,
                            hideLimitLabels: true,
                            showSelectionBar: true,
                            onChange: $scope.onSliderChange,
                            onEnd: $scope.onSliderEnd,
                            stepsArray: []
                        };
                        q.values.forEach(function (v) {
                            q.sliderOptions.stepsArray.push({ 'value': v.key });
                        });
                    }
                });
                // update questionsData with any prepopulation values
                $scope.questions.forEach(function (q) {
                    var prePopValue = null;
                    var queryStringParams = $location.search();
                    if (queryStringParams[q.id]) {
                        prePopValue = queryStringParams[q.id];
                        if (q.type != 'Text') {
                            var fullValue = q.values.filter(function (questionValue) { return questionValue.key == prePopValue; })[0];
                            $scope.questionsData[q.id] = fullValue;
                        } else {
                            $scope.questionsData[q.id] = prePopValue;
                        }
                    }
                });
                $scope.loadingStatus = false;
                questionsDataWatch($scope.questionsData, initialState); // manually call datawatch as we're triggering half way through watch cycle
                $timeout(function() {
                    $scope.$broadcast('rzSliderForceRender')
                });
            });
        };
        $scope.onSliderEnd = function (sliderId, modelValue, highValue, pointerType) {
            var question = $scope.questions.filter(function (q) {
                var response = (q.id == sliderId);
                return response;
            });
            var q = question[0];
            $scope.questionsData[q.id] = q.values[modelValue];
        };
        $scope.onSliderChange = function (sliderId, modelValue, highValue, pointerType) {
            var question = $scope.questions.filter(function (q) {
                var response = (q.id == sliderId);
                return response;
            });
            var q = question[0];
            q.legend = q.values[modelValue].value;
        };
        $scope.onFormSubmit = function () {
            var initialQuestions = [1, 2, 3];
            var secondaryQuestions = [5, 6, 7, 8, 9, 10];
            var questionSetId = parseInt($routeParams.stepId);

            var initialQSIndex = initialQuestions.indexOf(questionSetId);
            var secondaryQSIndex = secondaryQuestions.indexOf(questionSetId);

            if (initialQSIndex >= 0 && (initialQuestions.length - 1 != initialQSIndex)) {
                var nextQSIndex = parseInt(initialQSIndex) + 1;
                $scope.$location.url('/Step/' + (initialQuestions[nextQSIndex]));
            } else if (secondaryQSIndex >= 0 && (secondaryQuestions.length - 1 != secondaryQSIndex)) {
                var nextQSIndex = parseInt(secondaryQSIndex) + 1;
                $scope.$location.url('/Step/' + (secondaryQuestions[nextQSIndex]));
            } else {
                $scope.$location.url('/Results');// results page
            }
        };

        var questionsDataWatch = function (newval, oldval) {
            var request = [];
            for (var key in newval) {
                var newValValue = newval[key];
                if (typeof newValValue === 'string') {
                    if (newval[key] != oldval[key]) {
                        request.push({ "key": key, "value": newValValue });
                    }
                } else {
                    if (newval[key]["key"] != (oldval[key] || {})["key"]) {
                        request.push({ "key": key, "value": newValValue["key"] });
                    }
                }
            }
            if(request.length > 0)
            {
                var sessionId = localStorageService.get('sessionId');
                if (!sessionId) {
                    $http.post('/api/session', request, {})
                        .then(function successCallback(response) {
                            // this callback will be called asynchronously
                            // when the response is available
                            localStorageService.set('sessionId', response.data);
                        }, function errorCallback(response) {
                            // called asynchronously if an error occurs
                            // or server returns response with an error status.
    
                        });
                } else {
                    $http.patch('/api/session/' + sessionId, request, { headers: { 'Content-Type': 'application/json;charset=utf-8' } });
                }
            }
        }

        var sessionId = localStorageService.get('sessionId');
        if (sessionId) {
            SessionDataResource.query({ sessionId: sessionId }, function (sessionData) {
                $scope.sessionData = sessionData;
                $scope.loadData();
            });
        } else {
            $scope.sessionData = [];
            $scope.loadData();
        }


    }]);
